import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

export const DialogContent: FC<PropsWithChildren> = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  padding: 1em 1em;
  flex: 1;
  overflow: auto;
`;
